import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  * { margin: 0; padding: 0; box-sizing: border-box; }
  html, body, #root { height: 100%; font-family: 'Noto Serif JP', serif; background: #ffffff; color: #111111; }
  a { color: #ff761a; }
`;
